export const formatPhoneNumber = (
  number = "",
  separator = "-",
  shortened = false,
) => {
  if (!number) return number;

  let phone = shortened ? "" : `1${separator}`;
  if (number.length > 0) phone += number.substring(0, 3);
  if (number.length > 3) phone += `${separator}${number.substring(3, 6)}`;
  if (number.length > 6) phone += `${separator}${number.substring(6, 10)}`;
  return phone;
};
